export const RoutesNames = {
  PaymentConfirmation: 'payment-confirmation',
};
